import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach token from localStorage on every request (if present)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tc_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Global 401 handler: if auth is lost mid-session, clear stale token and
// bounce to /login (preserving the destination). This prevents the confusing
// raw "Not authenticated" toast from surfacing on any user action.
const AUTH_ROUTES = ["/dashboard", "/chat", "/insights", "/patterns", "/profile", "/settings", "/onboarding"];
let handling401 = false;
api.interceptors.response.use(
    (r) => r,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        // Ignore 401 from /auth/me itself — that's the app checking IF logged in
        // and is expected before login. Also ignore /auth/login|register (bad password should surface).
        const isBootCheck = url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/google-session");
        if (status === 401 && !isBootCheck && !handling401 && typeof window !== "undefined") {
            const pathname = window.location.pathname;
            const onAuthedRoute = AUTH_ROUTES.some((p) => pathname === p || pathname.startsWith(p + "/"));
            if (onAuthedRoute) {
                handling401 = true;
                localStorage.removeItem("tc_token");
                const current = pathname + window.location.search;
                setTimeout(() => {
                    handling401 = false;
                    window.location.replace(`/login?next=${encodeURIComponent(current)}&reason=expired`);
                }, 50);
            }
        }
        return Promise.reject(error);
    }
);
